__webpack_require__.p = "/reports-campaign-analytics/referrals-hub/";